import i18n from '../../helpers/i18n';

import InfoIcon from '../../icons/InfoIcon';
import RoboLogoIcon from '../../icons/RoboLogoIcon';
import StepIcon from '../../icons/StepIcon';

const UserBlocked = ({ lang, username }) => {
  return (
    <div className='main-banner-container'>
      <div className='main-banner'>
        <div className='main-banner__title-container'>
          <InfoIcon />
          <div className='main-banner__title'>
            {i18n.get('acceptProject.errorUserBlockedTitle', lang, { username })}
          </div>
          <div className='main-banner__subtitle'>
            {i18n.get('acceptProject.errorUserBlockedSubtitle', lang)}
          </div>
        </div>
        <div className='project-accepted-tutorial'>
          <div className='unblock-user-tutorial__step-container'>
            <div className='unblock-user-tutorial__step-description'>
              <StepIcon stepNumber='1' />
              <div>
                {i18n.get('acceptProject.errorUserBlockedStep1', lang)}
              </div>
            </div>
            <div className='project-accepted-tutorial__app-open'>
              <RoboLogoIcon />
              <div className='project-accepted-tutorial__app-open__app-name'>
                Robo Wunderkind
              </div>
            </div>
          </div>
          <div className='unblock-user-tutorial__step-container'>
            <div className='unblock-user-tutorial__step-description'>
              <StepIcon stepNumber='2' />
              <div>
                {i18n.get('acceptProject.errorUserBlockedStep2', lang)}
              </div>
            </div>
            <div className='unblock-user-preview__container'>
              <div className='unblock-user-preview__parental-control'>
                {i18n.get('acceptProject.errorUserBlockedParentalControl', lang)}
              </div>
              <div className='unblock-user-preview__greyed-out-option'/>
              <div className='unblock-user-preview__unblock'>
                {i18n.get('acceptProject.errorUserBlockedUnblock', lang)}
              </div>
              <div className='unblock-user-preview__greyed-out-option'/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBlocked;
